import { AssetIdCodec, CameraIdCodec, SiteIdCodec } from "@visioni/a3s-schema/codecs";
import z from "zod/v4";
import { LineCrossScenarioStatus } from "./events";

/**
 * Wire ↔ memory codec for one row of the tenant scenario-status list.
 * Tenant is omitted because the route is already tenant-scoped.
 */
export const TenantScenarioStatusItem = z.object({
  site: SiteIdCodec,
  asset: AssetIdCodec,
  camera: CameraIdCodec,
  scenarios: z.array(LineCrossScenarioStatus),
  updatedAt: z.iso.datetime(),
});

export type TenantScenarioStatusItemWire = z.input<typeof TenantScenarioStatusItem>;
export type TenantScenarioStatusItem = z.output<typeof TenantScenarioStatusItem>;

export const TenantScenarioStatusList = z.array(TenantScenarioStatusItem);

export type TenantScenarioStatusListWire = z.input<typeof TenantScenarioStatusList>;
export type TenantScenarioStatusList = z.output<typeof TenantScenarioStatusList>;
